<!-- Idea Modal Header Start-->
<div class="modal-header" *ngIf="idea">
  <ng-container *ngIf="!compactView; else compactHeader">
    <h3 class="modal-title d-xs-none d-md-block">
      Topic:
      <a routerLink="/topics/{{ session._id }}" (click)="dismiss()">
        {{ session.config.title }}
      </a>
    </h3>
    <div class="d-flex align-items-center ms-auto">
      <button
        *ngIf="!idea.i_follow"
        class="btn btn-lg icon-star-empty"
        (click)="follow()"
        title="Follow"></button>
      <button
        *ngIf="idea.i_follow"
        class="btn btn-lg icon-star-full"
        (click)="unfollow()"
        title="Unfollow"></button>
      <button
        *ngIf="permissions.session.data.ideas.delete(session, idea)"
        class="btn btn-lg fa fa-trash"
        (click)="deleteIdea()"
        title="Delete Project"></button>
      <a
        *ngIf="permissions.session.data.ideas.put(session, idea)"
        class="btn btn-lg fa fa-pencil-alt"
        (click)="dismiss()"
        routerLink="/topics/{{ session._id }}/ideas/{{ idea._id }}"
        [queryParams]="{ edit: 'true' }"
        title="Edit Project"></a>
      <button (click)="dismiss()" class="btn-close" title="Close"></button>
    </div>
  </ng-container>

  <ng-template #compactHeader>
    <h3 class="modal-title d-xs-none d-md-block">People</h3>
    <button (click)="dismiss()" class="btn-close" title="Close"></button>
  </ng-template>
</div>
<!-- Idea Modal Header End-->

<!-- Idea Modal Body Start-->
<ng-container *ngIf="!compactView; else compactBody">
  <div class="modal-body idea-modal clearfix">
    <div class="row content">
      <div class="col-8">
        <h2>{{ idea.title }}</h2>
        <h3>{{ idea.one_liner }}</h3>

        <div class="tags" *ngIf="idea.tags && idea.tags.length > 0">
          <div class="tags-wrapper">
            <div class="tag" *ngFor="let tag of idea.tags">{{ tag }}</div>
            <div class="spacer-tag tag"></div>
          </div>
          <div class="cutoff"></div>
        </div>

        <p class="idea-detail-description">
          <prosemirror-view
            [content]="idea.textScript?.original?.value || idea.descriptionRich"
            [simplified]="true"></prosemirror-view>
          <span class="description-fader"></span>
        </p>
        <a
          *ngIf="idea.moves && idea.moves.length > 0"
          class="move-notice d-xs-none d-md-block"
          [ngClass]="{
            active: permissions.session.data.ideas.put(session, idea),
          }"
          (click)="showMoveDetails()">
          <i class="icon-announcement"></i>
          This idea was moved to another topic
        </a>
        <a *ngIf="backlink" (click)="navigateToBacklink()">See Original Idea</a>
        <a
          class="pull-right"
          routerLink="/topics/{{ session._id }}/ideas/{{ idea._id }}"
          (click)="dismiss()">
          See details page…
        </a>
      </div>
      <div class="col-4 idea-thumbnail">
        <div
          [ngStyle]="{ 'background-image': 'url(' + thumbnailImage + ')' }"
          class="idea-thumbnail-image"></div>
        <button
          class="btn btn-primary"
          *ngIf="idea.created_by === session.me._id && !idea.published"
          ngbTooltip="A published idea is visible to every participant in the topic, while a private one is only visible to collaborators."
          placement="bottom"
          (click)="publish()">
          Publish Idea
        </button>
        <button
          class="btn btn-danger"
          *ngIf="idea.created_by === session.me._id && idea.published"
          ngbTooltip="A published idea is visible to every participant in the topic, while a private one is only visible to collaborators."
          placement="bottom"
          (click)="unpublish()">
          Make Private
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 bottom-section">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabIndex" class="nav-tabs">
          <li
            ngbNavItem="tab-0"
            *ngIf="session.config.benefits_and_challenges"
            (click)="broadcast()">
            <button ngbNavLink>Benefits &amp; Challenges</button>
            <ng-template ngbNavContent>
              <div class="col-4">
                <p><strong>Benefits:</strong></p>
                <form
                  class="form-inline"
                  *ngIf="permissions.session.data.ideas.benefits.post(session)">
                  <input
                    type="text"
                    class="form-control"
                    id="benefit-input"
                    name="benefit-input"
                    [(ngModel)]="benefit.text"
                    maxlength="{{ inputLengths.BENEFIT }}" />
                  <button
                    class="btn btn-primary"
                    (click)="benefit.text && addBenefit()">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </button>
                </form>
                <ul class="benefits-list">
                  <li *ngFor="let benefit of idea.benefits">
                    {{ benefit.text }}
                    <button
                      *ngIf="
                        permissions.session.data.ideas.benefits.delete(
                          session,
                          benefit
                        )
                      "
                      type="button"
                      (click)="deleteBenefit(benefit)"
                      title="Delete Benefit"
                      class="icon-button pull-right">
                      <i class="solution-icon fa fa-trash"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div class="col-4">
                <p><strong>Challenges:</strong></p>
                <form
                  class="form-inline"
                  *ngIf="
                    permissions.session.data.ideas.challenges.post(session)
                  ">
                  <input
                    type="text"
                    class="form-control"
                    id="challenge-input"
                    name="challenge-input"
                    [(ngModel)]="challenge.text"
                    maxlength="{{ inputLengths.CHALLENGE }}" />
                  <button
                    class="btn btn-primary"
                    (click)="challenge.text && addChallenge()">
                    <i class="fa fa-check" aria-hidden="true"></i>
                  </button>
                </form>
                <ul class="challenges-list">
                  <li *ngFor="let challenge of idea.challenges">
                    {{ challenge.text }}
                    <button
                      *ngIf="
                        permissions.session.data.ideas.challenges.delete(
                          session,
                          challenge
                        )
                      "
                      type="button"
                      (click)="deleteChallenge(challenge)"
                      class="icon-button pull-right"
                      title="Delete Challenge">
                      <i class="solution-icon muted fa fa-trash"></i>
                    </button>

                    <span
                      class="solutions-indicator pull-right"
                      *ngIf="
                        challenge.solutions.length > 0 &&
                        session.config.solutions
                      ">
                      ({{ challenge.solutions.length }})
                    </span>

                    <button
                      (click)="
                        challenge.solutionTriggered =
                          !challenge.solutionTriggered
                      "
                      title="Propose a solution"
                      class="icon-button pull-right"
                      *ngIf="session.config.solutions">
                      <i
                        class="far solution-icon fa-lightbulb"
                        [ngClass]="{ active: challenge.solutions.length > 0 }"
                        aria-hidden="true"></i>
                    </button>

                    <form
                      class="form-inline proposed-solution-form"
                      *ngIf="challenge.solutionTriggered">
                      <ul class="proposed-solutions-list">
                        <li
                          *ngFor="let solution of challenge.solutions"
                          [ngClass]="{ accepted: solution.accepted }">
                          {{ solution.text }}
                          <button
                            *ngIf="
                              permissions.session.data.ideas.challenges.solutions.delete(
                                session,
                                solution
                              )
                            "
                            type="button"
                            (click)="deleteSolution(challenge, solution)"
                            class="pull-right icon-button"
                            title="Delete solution">
                            <i class="solution-icon muted fa fa-trash"></i>
                          </button>

                          <button
                            *ngIf="
                              permissions.session.data.ideas.challenges.solutions.accept(
                                session,
                                challenge
                              ) && !solution.accepted
                            "
                            type="button"
                            (click)="acceptSolution(challenge, solution)"
                            class="icon-button pull-right"
                            title="Accept solution">
                            <i class="solution-icon far fa-square"></i>
                          </button>

                          <button
                            *ngIf="
                              permissions.session.data.ideas.challenges.solutions.unaccept(
                                session,
                                challenge,
                                solution
                              ) && solution.accepted
                            "
                            type="button"
                            (click)="unacceptSolution(challenge, solution)"
                            class="pull-right icon-button"
                            title="Unaccept solution">
                            <i class="solution-icon far fa-check-square"></i>
                          </button>
                        </li>
                      </ul>
                      <span
                        *ngIf="
                          permissions.session.data.ideas.challenges.solutions.post(
                            session
                          )
                        ">
                        <input
                          type="text"
                          class="form-control proposed-solution"
                          name="proposed-solution"
                          [(ngModel)]="solution.text"
                          maxlength="{{ inputLengths.SOLUTION }}" />
                        <button
                          class="btn btn-primary"
                          (click)="proposeSolution(challenge)">
                          Suggest Solution
                        </button>
                      </span>
                    </form>
                  </li>
                </ul>
              </div>
              <!-- <div
                class="col-4 rating-container position-relative"
                *ngIf="session.config.voting.active"
                [ngClass]="{
                  disabled: !permissions.session.data.ideas.vote(session, idea),
                }">
                <p><strong>Rating:</strong></p>
                <label class="form-label" for>
                  {{ session.config.axis.x }}
                  <span *ngIf="+sliderX.value !== sliderX.value">
                    (Not voted yet)
                  </span>
                </label>
                <ngx-slider
                  class="theme-slider"
                  (valueChange)="voteChange('x', $event)"
                  [(value)]="sliderX.value"
                  [manualRefresh]="sliderRefresh"
                  [options]="sliderX.options"></ngx-slider>

                <label class="form-label" for>
                  {{ session.config.axis.y }}
                  <span *ngIf="+sliderY.value !== sliderY.value">
                    (Not voted yet)
                  </span>
                </label>
                <ngx-slider
                  class="theme-slider"
                  (valueChange)="voteChange('y', $event)"
                  [(value)]="sliderY.value"
                  [manualRefresh]="sliderRefresh"
                  [options]="sliderY.options"></ngx-slider>

                <button
                  class="btn"
                  (click)="submitRating()"
                  [disabled]="!voteSubmit()">
                  Rate Idea
                </button>
                <div class="alert alert-warning mt-4" *ngIf="voteSubmit()">
                  Dont forget to submit your rating!
                </div>
                <div
                  class="alert alert-success"
                  *ngIf="ratingTransmitted && !voteSubmit()"
                  role="alert">
                  <strong>Thank you!</strong>
                </div>
              </div> -->
            </ng-template>
          </li>
          <li
            ngbNavItem="tab-1"
            *ngIf="
              session.config.comments.active ||
              !session.config.benefits_and_challenges
            ">
            <button ngbNavLink>Comments</button>
            <ng-template ngbNavContent>
              <div class="row">
                <div
                  class=""
                  [ngClass]="{
                    'col-12':
                      session.config.benefit_and_challenges ||
                      !session.config.voting.active,
                    'col-9':
                      !session.config.benefits_and_challenges &&
                      session.config.voting.active,
                  }"
                  *ngIf="session.config.comments.active">
                  <comment-list
                    [session]="session"
                    [idea]="idea"
                    [draft]="loadCommentDraft()"
                    (draftSave)="commentDraft($event)"></comment-list>
                </div>

                <!-- <div
                  class="col-3 rating-container position-relative"
                  [ngClass]="{
                    disabled: !permissions.session.data.ideas.vote(
                      session,
                      idea
                    ),
                  }"
                  *ngIf="
                    !session.config.benefits_and_challenges &&
                    session.config.voting.active
                  ">
                  <p><strong>Rating:</strong></p>
                  <label class="form-label" for>
                    {{ session.config.axis.x }}
                  </label>
                  <ngx-slider
                    class="theme-slider"
                    (valueChange)="voteChange('x', $event)"
                    [(value)]="sliderX.value"
                    [manualRefresh]="sliderRefresh"
                    [options]="sliderX.options"></ngx-slider>

                  <label class="form-label" for>
                    {{ session.config.axis.y }}
                  </label>
                  <ngx-slider
                    class="theme-slider"
                    (valueChange)="voteChange('y', $event)"
                    [(value)]="sliderY.value"
                    [manualRefresh]="sliderRefresh"
                    [options]="sliderY.options"></ngx-slider>

                  <button
                    class="btn btn-primary"
                    (click)="submitRating()"
                    [disabled]="!voteSubmit()">
                    Rate Idea
                  </button>
                  <div class="alert alert-warning mt-4" *ngIf="voteSubmit()">
                    Dont forget to submit your rating!
                  </div>
                  <div
                    class="alert alert-success"
                    *ngIf="ratingTransmitted && !voteSubmit()"
                    role="alert">
                    <strong>Thank you!</strong>
                  </div>
                </div> -->
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="tab-2">
            <button ngbNavLink>Followers</button>
            <ng-template ngbNavContent>
              <div class="col-12">
                <ng-container *ngIf="idea.followers.length > 0">
                  <p><strong>Followers:</strong></p>
                  <ul class="follower-list collaborator-list">
                    <ng-container *ngFor="let follower of idea.followers">
                      <li
                        *ngIf="
                          participantDict[follower.participant_id] &&
                          participantDict[follower.participant_id].user
                        "
                        class="collab-item">
                        <div class="left">
                          <profile-picture
                            [user]="
                              participantDict[follower.participant_id].user
                            "></profile-picture>
                          <name-tag
                            [user]="
                              participantDict[follower.participant_id].user
                            "
                            [hint]="true"></name-tag>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                </ng-container>
                <div *ngIf="idea.followers.length === 0">No followers yet.</div>
                <br />
                <button
                  *ngIf="!idea.i_follow"
                  class="btn btn-primary"
                  (click)="follow(idea)"
                  title="Follow">
                  <span class="far fa-star"></span>
                  Follow
                </button>
                <button
                  *ngIf="idea.i_follow"
                  class="btn btn-danger"
                  (click)="unfollow(idea)"
                  title="Unfollow">
                  <span class="fas fa-star" style="color: yellow"></span>
                  Unfollow
                </button>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="tab-3">
            <button ngbNavLink>Collaborators</button>
            <ng-template ngbNavContent>
              <div class="col-12">
                <span
                  *ngIf="
                    participantDict[idea.created_by] &&
                    participantDict[idea.created_by].user &&
                    participantDict[idea.created_by].user.name
                  ">
                  <p><strong>Originator:</strong></p>
                  <ul class="collaborator-list">
                    <li class="collab-item">
                      <div class="left">
                        <profile-picture
                          [user]="
                            participantDict[idea.created_by].user
                          "></profile-picture>
                        <name-tag
                          [user]="participantDict[idea.created_by].user"
                          [hint]="true"></name-tag>
                      </div>
                    </li>
                  </ul>
                </span>
                <ng-container *ngIf="idea.collaborators.length > 0">
                  <p><strong>Collaborators:</strong></p>

                  <ul class="collaborator-list">
                    <ng-container
                      *ngFor="let collaborator of idea.collaborators">
                      <li
                        *ngIf="
                          participantDict[collaborator.participant_id] &&
                          participantDict[collaborator.participant_id].user
                        "
                        class="collab-item">
                        <div class="left">
                          <profile-picture
                            [user]="
                              participantDict[collaborator.participant_id].user
                            "></profile-picture>
                          <name-tag
                            [user]="
                              participantDict[collaborator.participant_id].user
                            "
                            [hint]="true"></name-tag>
                        </div>
                        <div class="right">
                          <button
                            *ngIf="
                              permissions.session.data.ideas.collaborators.delete(
                                session,
                                collaborator,
                                idea
                              )
                            "
                            type="button"
                            class="btn btn-danger"
                            (click)="deleteCollaborator(collaborator)">
                            Remove
                          </button>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                  <br />
                </ng-container>
                <p *ngIf="!idea.collaborators.length">No collaborators</p>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    )
                  ">
                  <ng-container *ngIf="collaborationRequestors.length > 0">
                    <p><strong>Collaboration Requests:</strong></p>
                    <ul class="collaborator-list">
                      <ng-container
                        *ngFor="let requestor of collaborationRequestors">
                        <li
                          class="collab-item"
                          *ngIf="requestor && requestor.user">
                          <div class="left">
                            <profile-picture
                              [user]="requestor.user"></profile-picture>
                            <name-tag
                              [user]="requestor.user"
                              [hint]="true"></name-tag>
                          </div>
                          <div class="right">
                            <button
                              type="button"
                              class="btn btn-primary"
                              (click)="approveCollaboratorRequest(requestor)">
                              Approve
                            </button>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>

                  <p *ngIf="!collaborationRequestors.length">
                    No open collaboration requests
                  </p>
                </div>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    ) &&
                    idea.collaboratorInvites &&
                    idea.collaboratorInvites.length > 0
                  ">
                  <p><strong>Invited Collaborators (Pending):</strong></p>
                  <ul class="collaborator-list">
                    <li
                      *ngFor="let invite of idea.collaboratorInvites"
                      class="collab-item">
                      <div class="left">
                        <profile-picture [user]="invite.user"></profile-picture>
                        <name-tag [user]="invite.user" [hint]="true"></name-tag>
                      </div>
                      <div class="right">
                        <button
                          *ngIf="
                            permissions.session.data.ideas.collaborators.delete(
                              session,
                              collaborator,
                              idea
                            )
                          "
                          type="button"
                          class="btn btn-danger"
                          (click)="removeCollabInvite(invite)">
                          Remove
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>

                <br />

                <div
                  *ngIf="
                    !permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    ) && !currentUserHasRequestedCollaboration()
                  ">
                  <ng-container *ngIf="!isInvitedAsCollaborator()">
                    <button
                      class="btn btn-primary"
                      (click)="requestToBeCollaborator()">
                      Request to be Collaborator
                    </button>
                  </ng-container>
                  <ng-container *ngIf="isInvitedAsCollaborator()">
                    <p>You have been invited to collaborate on this idea!</p>
                    <button
                      class="btn btn-danger"
                      (click)="rejectCollaborationInvite()">
                      Reject
                    </button>
                    &nbsp;
                    <button
                      class="btn btn-primary"
                      (click)="acceptCollaborationInvite()">
                      Accept
                    </button>
                  </ng-container>
                </div>

                <div *ngIf="currentUserHasRequestedCollaboration()">
                  You have requested to be a collaborator on this idea.
                </div>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    )
                  ">
                  <button
                    class="btn btn-primary"
                    (click)="openAddCollaboratorModal()">
                    Add Collaborator
                  </button>

                  <button
                    *ngIf="session.config.expert_finder"
                    class="btn btn-secondary suggest-collab"
                    (click)="openCollaboratorSuggestionModal()">
                    Suggested Collaborators
                  </button>
                </div>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="tab-4" *ngIf="idea.morphboxes.length">
            <button ngbNavLink>Morphbox Properties</button>
            <ng-template ngbNavContent>
              <div class="col-12">
                <table *ngFor="let morphbox of idea.morphboxes">
                  <thead>
                    <td>Properties ({{ morphbox.name }})</td>
                    <td>Values</td>
                  </thead>
                  <tr *ngFor="let row of morphbox.rows">
                    <td>
                      {{ row.text }}
                    </td>
                    <td>
                      <span
                        class="morphbox-value"
                        *ngFor="let value of row.elements">
                        {{ value }}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #compactBody>
  <div class="modal-body idea-modal clearfix">
    <div class="row">
      <div class="col-12 bottom-section">
        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabIndex" class="nav-tabs">
          <li ngbNavItem="tab-3">
            <button ngbNavLink>Collaborators</button>
            <ng-template ngbNavContent>
              <div class="col-12">
                <span
                  *ngIf="
                    participantDict[idea.created_by] &&
                    participantDict[idea.created_by].user &&
                    participantDict[idea.created_by].user.name
                  ">
                  <p><strong>Originator:</strong></p>
                  <ul class="collaborator-list">
                    <li class="collab-item">
                      <div class="left">
                        <profile-picture
                          [user]="
                            participantDict[idea.created_by].user
                          "></profile-picture>
                        <name-tag
                          [user]="participantDict[idea.created_by].user"
                          [hint]="true"></name-tag>
                      </div>
                    </li>
                  </ul>
                </span>
                <ng-container *ngIf="idea.collaborators.length > 0">
                  <p><strong>Collaborators:</strong></p>

                  <ul class="collaborator-list">
                    <ng-container
                      *ngFor="let collaborator of idea.collaborators">
                      <li
                        *ngIf="
                          participantDict[collaborator.participant_id] &&
                          participantDict[collaborator.participant_id].user
                        "
                        class="collab-item">
                        <div class="left">
                          <profile-picture
                            [user]="
                              participantDict[collaborator.participant_id].user
                            "></profile-picture>
                          <name-tag
                            [user]="
                              participantDict[collaborator.participant_id].user
                            "
                            [hint]="true"></name-tag>
                        </div>
                        <div class="right">
                          <button
                            *ngIf="
                              permissions.session.data.ideas.collaborators.delete(
                                session,
                                collaborator,
                                idea
                              )
                            "
                            type="button"
                            class="btn btn-danger"
                            (click)="deleteCollaborator(collaborator)">
                            Remove
                          </button>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                  <br />
                </ng-container>
                <p *ngIf="!idea.collaborators.length">No collaborators</p>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    )
                  ">
                  <ng-container *ngIf="collaborationRequestors.length > 0">
                    <p><strong>Collaboration Requests:</strong></p>
                    <ul class="collaborator-list">
                      <ng-container
                        *ngFor="let requestor of collaborationRequestors">
                        <li
                          class="collab-item"
                          *ngIf="requestor && requestor.user">
                          <div class="left">
                            <profile-picture
                              [user]="requestor.user"></profile-picture>
                            <name-tag
                              [user]="requestor.user"
                              [hint]="true"></name-tag>
                          </div>
                          <div class="right">
                            <button
                              type="button"
                              class="btn btn-primary"
                              (click)="approveCollaboratorRequest(requestor)">
                              Approve
                            </button>
                          </div>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>

                  <p *ngIf="!collaborationRequestors.length">
                    No open collaboration requests
                  </p>
                </div>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    ) &&
                    idea.collaboratorInvites &&
                    idea.collaboratorInvites.length > 0
                  ">
                  <p><strong>Invited Collaborators (Pending):</strong></p>
                  <ul class="collaborator-list">
                    <li
                      *ngFor="let invite of idea.collaboratorInvites"
                      class="collab-item">
                      <div class="left">
                        <profile-picture [user]="invite.user"></profile-picture>
                        <name-tag [user]="invite.user" [hint]="true"></name-tag>
                      </div>
                      <div class="right">
                        <button
                          *ngIf="
                            permissions.session.data.ideas.collaborators.delete(
                              session,
                              collaborator,
                              idea
                            )
                          "
                          type="button"
                          class="btn btn-danger"
                          (click)="removeCollabInvite(invite)">
                          Remove
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>

                <br />

                <div
                  *ngIf="
                    !permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    ) && !currentUserHasRequestedCollaboration()
                  ">
                  <ng-container *ngIf="!isInvitedAsCollaborator()">
                    <button
                      class="btn btn-primary"
                      (click)="requestToBeCollaborator()">
                      Request to be Collaborator
                    </button>
                  </ng-container>
                  <ng-container *ngIf="isInvitedAsCollaborator()">
                    <p>You have been invited to collaborate on this idea!</p>
                    <button
                      class="btn btn-danger"
                      (click)="rejectCollaborationInvite()">
                      Reject
                    </button>
                    &nbsp;
                    <button
                      class="btn btn-primary"
                      (click)="acceptCollaborationInvite()">
                      Accept
                    </button>
                  </ng-container>
                </div>

                <div *ngIf="currentUserHasRequestedCollaboration()">
                  You have requested to be a collaborator on this idea.
                </div>

                <div
                  *ngIf="
                    permissions.session.data.ideas.collaborators.post(
                      session,
                      idea
                    )
                  ">
                  <button
                    class="btn btn-primary"
                    (click)="openAddCollaboratorModal()">
                    Add Collaborator
                  </button>

                  <button
                    *ngIf="session.config.expert_finder"
                    class="btn btn-secondary suggest-collab"
                    (click)="openCollaboratorSuggestionModal()">
                    Suggested Collaborators
                  </button>
                </div>
              </div>
            </ng-template>
          </li>
          <li ngbNavItem="tab-2">
            <button ngbNavLink>Followers</button>
            <ng-template ngbNavContent>
              <div class="col-12">
                <ng-container *ngIf="idea.followers.length > 0">
                  <p><strong>Followers:</strong></p>
                  <ul class="follower-list collaborator-list">
                    <ng-container *ngFor="let follower of idea.followers">
                      <li
                        *ngIf="
                          participantDict[follower.participant_id] &&
                          participantDict[follower.participant_id].user
                        "
                        class="collab-item">
                        <div class="left">
                          <profile-picture
                            [user]="
                              participantDict[follower.participant_id].user
                            "></profile-picture>
                          <name-tag
                            [user]="
                              participantDict[follower.participant_id].user
                            "
                            [hint]="true"></name-tag>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                </ng-container>
                <div *ngIf="idea.followers.length === 0">No followers yet.</div>
                <br />
                <button
                  *ngIf="!idea.i_follow"
                  class="btn btn-primary"
                  (click)="follow(idea)"
                  title="Follow">
                  <span class="far fa-star"></span>
                  Follow
                </button>
                <button
                  *ngIf="idea.i_follow"
                  class="btn btn-danger"
                  (click)="unfollow(idea)"
                  title="Unfollow">
                  <span class="fas fa-star" style="color: yellow"></span>
                  Unfollow
                </button>
              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</ng-template>
<!-- Idea Modal Body End-->
